import React from 'react';
import AppLayout from '../../layouts/AppLayout';
import VideosList from './components/VideosList';
import useVideosDomain from './hooks/useVideosDomain';
import './styles.css';

function VideosPage() {
  const state = useVideosDomain();

  return (
    <AppLayout
      title="Vídeos"
      subtitle="Biblioteca e monitoramento de geração"
      fullWidth
    >
      <VideosList state={state} />
    </AppLayout>
  );
}

export default VideosPage;
